import React from 'react';
import { Text } from '@wix/design-system';
export const BodyCell = ({ children, ...props }) => {
    return (React.createElement(Text, { size: "small", weight: "normal", ...props }, children));
};
//# sourceMappingURL=BodyCell.js.map